import script from "./ThePlanView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThePlanView.vue?vue&type=script&setup=true&lang=ts"

import "./ThePlanView.vue?vue&type=style&index=0&id=f1f90f16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1f90f16"]])

export default __exports__